'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receivedWidgetShellData = exports.receivedWidgetData = undefined;
exports.default = bootstrapWidget;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _gdprConsentToProcessEnabled = require('conversations-schema/operators/widget-data/gdprConsentToProcessEnabled');

var _addConversation = require('./ConversationsActions/addConversation');

var _setCurrentChannel = require('./ConversationsActions/setCurrentChannel');

var _stubbedChannel = require('../threads/constants/stubbedChannel');

var _buildStubbedThread = require('../threads/factories/buildStubbedThread');

var _prospectUtkSelectors = require('../selectors/prospectUtkSelectors');

var _handleStoreMessagesCookie = require('../post-message/actions/handleStoreMessagesCookie');

var _trackInteraction = require('../usage-tracking/actions/trackInteraction');

var _buildWidgetData = require('../widget-data/operators/buildWidgetData');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var receivedWidgetData = exports.receivedWidgetData = (0, _reduxActions.createAction)(ActionTypes.GET_WIDGET_DATA_SUCCEEDED, function (widgetData) {
  return widgetData;
});

var receivedWidgetShellData = exports.receivedWidgetShellData = (0, _reduxActions.createAction)(_VisitorActionTypes.RECEIVED_WIDGET_SHELL_DATA);

function bootstrapWidget(data) {
  return function (dispatch, getState) {
    var widgetData = (0, _buildWidgetData.buildWidgetData)(data);

    if (!(0, _get2.default)('sessionId', widgetData)) {
      window.Raven.captureMessage('MISSING_SESSION_ID', {
        extra: {
          widgetData: widgetData && widgetData.toJS()
        },
        level: 'info'
      });

      return;
    }

    dispatch((0, _addConversation.addConversation)((0, _buildStubbedThread.buildStubbedThread)()));
    dispatch((0, _setCurrentChannel.setCurrentChannel)(_stubbedChannel.STUBBED_CHANNEL));

    var shouldStoreMessagesCookie = !(0, _gdprConsentToProcessEnabled.gdprConsentToProcessEnabled)(widgetData);

    if (shouldStoreMessagesCookie) {
      dispatch((0, _handleStoreMessagesCookie.handleStoreMessagesCookie)((0, _prospectUtkSelectors.getMessagesUtk)(getState())));
    }

    dispatch((0, _trackInteraction.trackInteraction)('pageview', {
      screen: 'widget',
      subscreen: 'thread view',
      action: 'rendered widget'
    }));

    dispatch(receivedWidgetData(widgetData));
    dispatch(receivedWidgetShellData(data));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/bootstrapWidget.js
// module id = 311
// module chunks = 2 3